/**
 * Phase 2 Wave 6 Agent S3 -- Session Management API client.
 *
 * Mirrors backend/app/api/session_management.py (mounted under /sessions).
 */
import { api } from '@/lib/api'

export interface ActiveSession {
  id: number
  ip: string | null
  user_agent: string | null
  created_at: string | null
  last_seen_at: string | null
  expires_at: string | null
}

export interface ActiveSessionsResponse {
  sessions: ActiveSession[]
  total: number
}

export interface TimeoutConfig {
  tenant_id: number
  idle_timeout_minutes: number
  max_concurrent_sessions: number
  force_logout_on_password_change: boolean
}

export interface TimeoutConfigUpdate {
  idle_timeout_minutes?: number
  max_concurrent_sessions?: number
  force_logout_on_password_change?: boolean
}

export const sessionManagementApi = {
  listActive: async (): Promise<ActiveSessionsResponse> => {
    const response = await api.get<ActiveSessionsResponse>('/sessions/active')
    return response.data
  },

  revokeSession: async (sessionId: number): Promise<{ success: boolean; revoked: number }> => {
    const response = await api.delete(`/sessions/${sessionId}`)
    return response.data
  },

  revokeAllOthers: async (
    currentSessionId?: number,
  ): Promise<{ success: boolean; revoked: number }> => {
    const response = await api.delete('/sessions/all-others', {
      params: currentSessionId ? { current_session_id: currentSessionId } : undefined,
    })
    return response.data
  },

  getTimeoutConfig: async (): Promise<TimeoutConfig> => {
    const response = await api.get<TimeoutConfig>('/sessions/timeout-config')
    return response.data
  },

  updateTimeoutConfig: async (
    payload: TimeoutConfigUpdate,
  ): Promise<TimeoutConfig> => {
    const response = await api.patch<TimeoutConfig>(
      '/sessions/timeout-config',
      payload,
    )
    return response.data
  },
}
